import { render, staticRenderFns } from "./AVContract.vue?vue&type=template&id=17837fb0&"
import script from "./AVContract.vue?vue&type=script&lang=js&"
export * from "./AVContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports